import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Content from "../../common/Content";
import DifficultySelector from "../../ui/DifficultySelector";
import GameArea from "../../ui/GameArea";
import PlayButton from "../../ui/PlayButton";
import NumberJungleLevel from "./NumberJungleLevel";

const GameOverDiv = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: rgba(242, 205, 206, 0.9);
  font-size: 20px;
`;

const GameOverScreen = () => {
  return (
    <GameOverDiv>
      <strong style={{ fontSize: "25px" }}>Gute Arbeit!</strong>
      <br />
      Sie haben alle Zahlen gefunden. Klicken sie auf "Neue Anordnung der
      Zahlen" in der unteren linken Ecke um erneut zu spielen.
    </GameOverDiv>
  );
};

export default ({ onSetLevel, game }: any) => {
  const { t } = useTranslation("games");
  const [gameOver, setGameOver] = useState(false);
  const [level, setLevel] = useState(1);
  const [started, setStarted] = useState(false);
  const [shuffle, setShuffle] = useState(0);

  useEffect(() => {
    setStarted(false);
  }, [level]);

  const startGame = () => {
    setStarted(true);
    setGameOver(false);
  };

  const shuffleNumbers = () => {
    setShuffle(shuffle + 1);
    setGameOver(false);
  };

  return (
    <>
      <GameArea showDetail={!gameOver} game={game}>
        {gameOver && <GameOverScreen />}
        <NumberJungleLevel
          disabled={!started}
          shuffle={shuffle}
          level={level}
          setGameOver={setGameOver}
        />
      </GameArea>
      <Content>
        <div>
          {started ? (
            <PlayButton onClick={shuffleNumbers}>
              Neue Anordnung der Zahlen
            </PlayButton>
          ) : (
            <PlayButton onClick={startGame} />
          )}
        </div>
        <DifficultySelector
          switchDifficulty={(level) => {
            onSetLevel(level);
            setGameOver(false);
            setLevel(level);
          }}
          levels={3}
          current={level}
        />
      </Content>
    </>
  );
};
